import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=e801c1f0"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports